<template lang="pug">
    .questionnaire-aas
        app-text-field.result-field(
            v-model="result"
            label="AAS"
            is-number
            :max="105"
            :error="error"
            :disabled="disabled"
        )

        //app-link(
            @click="openModal"
            //:disabled="disabled"
        //) Рассчитать

        questionnaire-modal(ref="modal")
            .title Расчет AAS

            .block
                .block-question(v-for="(question, id) in questions")
                    .block-question__name(v-html="question.name")
                    .app-choice-group(v-if="question.answers")
                        app-choice(
                            v-for="answer in question.answers"
                            v-model="question.value"
                            type="radio"
                            :label="answer.name"
                            :radio-value="answer.value"
                            :error="$v.$dirty && $v.questions.$each.$iter[id].value.$invalid"
                        )
                    .app-choice-group(v-else)
                        app-choice(
                            v-for="variant in question.variants"
                            v-model="variant.isSelected"
                            type="checkbox"
                            :label="variant.name"
                            :radio-value="variant.value"
                            :error="$v.$dirty && $v.questions.$each.$iter[id].value.$invalid"
                        )

            .bottom
                .result(v-if="tempResult !== null") AAS = <b>{{ tempResult }}</b>
                app-button(
                    large
                    @click="calculate"
                ) Рассчитать
                app-button(
                    large
                    color="white"
                    :disabled="tempResult === null"
                    @click="save"
                ) Сохранить рассчет
</template>

<script>
import questionnaireMixin from '@/mixins/questionnaireMixin';

export default {
    name: 'questionnaire-aas',

    mixins: [questionnaireMixin],

    data: () => ({
        questions: {
            1: {
                name: 'В течение какого времени присутствовал отек/отеки)?',
                variants: [
                    { name: '0:00–8:00 ч', isSelected: false, value: 1 },
                    { name: '8:00–16:00 ч', isSelected: false, value: 1 },
                    { name: '16:00–24:00 ч', isSelected: false, value: 1 },
                ],
            },
            2: {
                name: 'Насколько сильными являются или являлись вызванные отеком/отеками симптомы (например, боль, жжение, зуд)?',
                answers: [
                    { name: 'Симптомов нет/не было', value: 0 },
                    { name: 'Легкие', value: 1 },
                    { name: 'Средние', value: 2 },
                    { name: 'Сильные', value: 3 },
                ],
                value: null,
            },
            3: {
                name: 'Насколько отек/отеки ограничивают или ограничивали Вашу повседневную деятельность?',
                answers: [
                    { name: 'Без ограничений', value: 0 },
                    { name: 'Немного', value: 1 },
                    { name: 'Значительно', value: 2 },
                    { name: 'Полностью (заниматься повседневной деятельностью (было) невозможно)', value: 3 },
                ],
                value: null,
            },
            4: {
                name: 'Как Вы&nbsp;считаете, данный отек/отеки негативно отражаются (отразились) на&nbsp;Вашем внешнем виде?',
                answers: [
                    { name: 'Нет', value: 0 },
                    { name: 'Немного', value: 1 },
                    { name: 'Умеренно', value: 2 },
                    { name: 'Сильно', value: 3 },
                ],
                value: null,
            },
            5: {
                name: 'Как бы Вы оценили общую выраженность/тяжесть данного отека/отеков?',
                answers: [
                    { name: 'Несущественная', value: 0 },
                    { name: 'Слабая', value: 1 },
                    { name: 'Средняя', value: 2 },
                    { name: 'Сильная', value: 3 },
                ],
                value: null,
            },
        },
    }),

    validations: {
        questions: {
            $each: {
                value: {
                    required(value, question) {
                        return question.answers ? value !== null : question.variants.some(v => v.isSelected);
                    },
                },
            },
        },
    },

    methods: {
        calculate() {
            if (this.$v.$invalid) {
                this.$v.$touch();
                this.$refs.modal.scrollToInvalidField();
                return;
            }

            this.tempResult = Object.values(this.questions).reduce((sum, question) => {
                if (question.answers) {
                    sum += question.value;
                } else {
                    sum += question.variants
                        .filter(v => v.isSelected)
                        .reduce((sumV, v) => sumV + v.value, 0);
                }
                return sum;
            }, 0);
        },
    },
};
</script>

<style scoped lang="scss">
.questionnaire-aas {
    .result-field {
        width: rem(63px);
    }

    @include mobile_or_P {
        .result-field {
            width: rem(200px);
            margin-right: 1.5rem;
        }
    }
}
</style>
